export const setNews = (value, page, limit, count) => {
    return {
      type: 'SET_NEWS',
      payload: { data: value, page, limit, count }
    };
  };